module.exports = __webpack_public_path__ + "img/eur.02e6a63d.svg";